import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/jb-teaser-meta/jb-teaser-meta.css.ts
var jb_teaser_meta_css_default = i`.timezone{font-family:var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);font-style:normal;font-weight:var(--theme-font-light-weight, 300)}.timezone{font-size:var(--theme-typo-p-mini-desktop-fontsize, 0.813rem);line-height:var(--theme-typo-p-mini-desktop-lineheight, 1.25rem)}:host{align-items:flex-start;display:flex;flex-direction:column;gap:var(--category-spacing-top, var(--spacing-s, 20px))}.info{align-items:center;display:flex;flex-wrap:wrap;gap:var(--spacing-s)}.date,.time,.timezone{align-items:center;display:inline-flex;gap:var(--spacing-base)}jb-calendar-icon,jb-globe-icon{display:inline-flex;height:26px;padding:5px;width:26px}`;

export {
  jb_teaser_meta_css_default
};
